import { Bot } from "lucide-react";
import { SourceStateCard } from "../SourceStateCard";
import type { AgentCreatedDiff } from "./AuditTrail/AuditTrail.utils";

const formatAccepter = ({ acceptedByFirstName, acceptedByLastName }: AgentCreatedDiff) =>
  [acceptedByFirstName, acceptedByLastName ? `${acceptedByLastName[0]}.` : undefined].filter(Boolean).join(" ");

export const AgentProvenance = ({ diff }: { diff: AgentCreatedDiff }) => {
  const accepter = formatAccepter(diff);
  const acceptedOn = new Date(diff.dateTime).toLocaleDateString(undefined, { month: "short", day: "numeric" });

  return (
    <SourceStateCard icon={Bot} title={diff.summary}>
      <p>Proposed by estimate agent</p>
      <p className="mt-1">
        {accepter ? `Accepted by ${accepter}` : "Accepted"} · {acceptedOn}
      </p>
    </SourceStateCard>
  );
};
